<script>
	import SvelteMarkdown from "svelte-markdown";

	export let onClose;
	export let text = `Instructions`;
</script>

<div class="pre">👇 How your text will appear👇</div>

<!-- mangle false to ensure email works (https://marked.js.org/using_advanced#options) -->
<SvelteMarkdown source={text} options={{ mangle: false }} />

<button on:click|preventDefault={onClose}>Continue</button>

<style>
	.pre {
		text-align: center;
		font-size: 0.8em;
	}
	button {
		margin: auto;
		display: block;
	}
</style>
